export default __webpack_public_path__ + "static/media/phoenix-attachment-icon.bb87a316.svg";